import { CSSProperties } from 'vue'
import { ColumnT } from './BuilderColumn.vue'
import { Row } from './BuilderRow.vue'

export const createDivider = (): Row => ({
  cols: [
    {
      type: 'divider',
      style: {
        flex: '1',
        padding: '8px 0 8px 0'
      },
      props: {}
    }
  ]
})

export const createSmallTitle = (text: string, override?: Partial<ColumnT<'text'>>): Row => ({
  cols: [
    {
      type: 'text',
      style: {
        flex: '1',
        ...override?.style
      },
      props: {
        text,
        weight: 'bold',
        ...override?.props
      }
    }
  ]
})

export const createSmallSubtitle = (text: string, override?: Partial<ColumnT<'text'>>): Row => ({
  cols: [
    {
      type: 'text',
      style: {
        flex: '1'
      },
      props: {
        text,
        type: 'tiny',
        color: 'secondary',
        weight: 'bold'
      },
      ...override
    }
  ]
})

export const createSmallIconSubtitle = (
  text: string,
  icon: string,
  style?: CSSProperties
): Row => ({
  cols: [
    {
      type: 'component',
      style: {
        marginRight: '4px',
        width: '12px',
        height: '12px',
        alignSelf: 'center'
      },
      props: {
        is: icon
      }
    },
    {
      type: 'text',
      style: {
        flex: '1',
        alignSelf: 'center'
      },
      props: {
        text: text,
        type: 'tiny',
        color: 'secondary',
        weight: 'bold'
      }
    }
  ],
  style
})

export const createText = (text: string): Row => ({
  cols: [
    {
      type: 'text',
      props: {
        text
      }
    }
  ]
})

export const createTinyText = (text: string): Row => ({
  cols: [
    {
      type: 'text',
      props: {
        text,
        type: 'tiny'
      }
    }
  ]
})

export const createTinyBoldText = (text: string, override?: Partial<ColumnT<'text'>>): Row => ({
  cols: [
    {
      type: 'text',
      props: {
        text,
        type: 'tiny',
        weight: 'bold'
      },
      ...override
    }
  ]
})

export const createColorCircleLabel = (
  color: string,
  label: string,
  style?: CSSProperties
): Row => ({
  cols: [
    {
      type: 'color-circle' as const,
      style: {
        width: '16px',
        height: '16px',
        marginRight: '4px'
      },
      props: {
        color
      }
    },
    {
      type: 'text' as const,
      style: {
        flex: '1'
      },
      props: {
        text: label,
        type: 'label' as const,
        weight: 'bold' as const,
        underline: false
      }
    }
  ],
  style
})

export const createButton = (
  label: string,
  emit: string,
  palette: 'primary' | 'secondary',
  tabIndex?: number
): Row => ({
  cols: [
    {
      type: 'button',
      style: {
        flex: '1',
        padding: '0 0 8px 0'
      },
      props: {
        label,
        size: 'small',
        tabIndex,
        palette,
        emit
      }
    }
  ]
})

export const createPrimaryButton = (label: string, emit: string, tabIndex?: number): Row =>
  createButton(label, emit, 'primary', tabIndex)

export const createSecondaryButton = (label: string, emit: string, tabIndex?: number): Row =>
  createButton(label, emit, 'secondary', tabIndex)
